import { useShallow } from "zustand/react/shallow";

import Feedback from "ds/components/Feedback";

import { selectBudgetResetsIn, selectIsBudgetExhausted } from "../store/selectors";
import useChatStore from "../store/useStore";
import styles from "./styles.module.css";

const ChatBudgetExhaustedBanner = () => {
  const budgetUsage = useChatStore(useShallow((state) => state.budgetUsage));

  if (!budgetUsage || budgetUsage.totalTokens === -1 || !selectIsBudgetExhausted(budgetUsage)) {
    return undefined;
  }

  const resetsIn = selectBudgetResetsIn(budgetUsage);

  return (
    <Feedback
      variant="danger"
      type="banner"
      storageKey="chat-budget-exhausted"
      className={styles.budgetExhaustedBanner}
    >
      Monthly tokens limit reached. Resets in {resetsIn}.
    </Feedback>
  );
};

export default ChatBudgetExhaustedBanner;
